// Which PBX this deployment's softphone registers against, and how its media
// gets through NAT.
//
// LIFTED OUT OF VoiceSoftphone.tsx because it is no longer only that page's
// business: SipContext restores a registration after a browser refresh, which
// can happen on any route, so it needs the same defaults without importing the
// page. One definition, two callers — the alternative was a second copy that
// would drift the day someone set VITE_PBX_WSS and only half the app noticed.
//
// ── Which PBX ───────────────────────────────────────────────────────────────
// Configurable per environment via Vite env vars, because it was previously
// hardcoded — every environment (local, dev, staging, prod) compiled the same
// address into the bundle, so pointing dev at a different PBX meant editing a
// source file and changing it for everyone.
//
//   VITE_PBX_DOMAIN=pbx.helixai.cx
//   VITE_PBX_WSS=wss://pbx.helixai.cx:8089/ws
//
// Defaults preserve the existing behaviour, so nothing changes unless set.
//
// NOTE: pointing a deployment at a PBX is only half the story — that PBX also
// has to be provisioned FROM the database that deployment writes to. Asterisk
// reads its endpoints via rt-sync, which pulls from ONE database; if this
// environment's DB isn't that one, agents created here will never exist on the
// PBX and registration fails no matter what address is set here.
const PBX_DOMAIN = (import.meta.env.VITE_PBX_DOMAIN as string | undefined) || "pbx.helixai.cx";

// ── ICE ─────────────────────────────────────────────────────────────────────
// STUN alone only discovers the browser's public address — it cannot relay.
// When the agent and the PBX are both behind restrictive NAT there is no direct
// candidate pair, ICE goes to `failed`, and the call drops a few seconds after
// it is answered. A TURN relay is the fix, and both design docs list coturn as
// required infrastructure (telephony §9, live-agent §11).
//
// Configured via Vite env so a deployment can add TURN with no code change:
//   VITE_TURN_URL=turn:turn.helixai.cx:3478
//   VITE_TURN_USERNAME=…      VITE_TURN_CREDENTIAL=…
// Long-lived static TURN creds in the bundle are a stopgap; the durable answer
// is short-lived credentials issued alongside the SIP creds (see
// docs/live-agent-softphone.md §6, which specifies exactly that endpoint).
const TURN_URL = import.meta.env.VITE_TURN_URL as string | undefined;

export const ICE_SERVERS: RTCIceServer[] = [
  { urls: "stun:stun.l.google.com:19302" },
  ...(TURN_URL
    ? [{
        urls: TURN_URL,
        username: import.meta.env.VITE_TURN_USERNAME as string | undefined,
        credential: import.meta.env.VITE_TURN_CREDENTIAL as string | undefined,
      } as RTCIceServer]
    : []),
];

export const PBX = {
  wss: (import.meta.env.VITE_PBX_WSS as string | undefined) || `wss://${PBX_DOMAIN}:8089/ws`,
  domain: PBX_DOMAIN,
  iceServers: ICE_SERVERS,
};
